import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import MedicineList from '../ProductDetail/MedicineList';
import OrderOnCallButton from '../Button/OrderOnCallButton';
import * as Constants from '../../constants';
import * as Helper from '../../utils/helper';
import * as actions from '../../actions';
import './PastOrderItem.scss';

class PastOrderItem extends Component {
  constructor(props) {
    super(props);
    const { orderDetails } = this.props;

    this.state = {
      isCollapsed: true,
      medicines: [],
      isOrderDelivered: orderDetails.canReorder,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { pastOrders, orderDetails } = this.props;
    const type =
      nextProps.pastOrders.action && nextProps.pastOrders.action.type;
    const oldType = pastOrders.action && pastOrders.action.type;
    if (
      nextProps.index === this.props.currentIndex &&
      nextProps.buttonLoading !== this.props.buttonLoading
    ) {
      this.setState({ isLoading: true });
    }
    if (type === oldType) {
      return;
    }

    switch (type) {
      case Constants.FETCH_ORDER_SUCCESS: {
        let data = {};
        const { orderMedicinesMap } = nextProps.pastOrders;
        if (
          this.props.customer.omsEnabled &&
          this.props.orderDetails.isNewOrderFlow
        ) {
          data = nextProps.pastOrders.data;
        } else {
          data = nextProps.pastOrders.data.data;
        }
        if (data && String(data.id) !== String(orderDetails.id)) {
          break;
        }
        const medicines = orderMedicinesMap[orderDetails.id] || [];
        this.setState({
          medicines,
        });
        break;
      }
      default:
      // no-op
    }
  }

  addAllMedicines = () => {
    Helper.addAllMedicines(
      this.props.actions,
      this.props.orderDetails.id,
      this.props.orderDetails.isNewOrderFlow
    );
  };

  toggleMedicineView = () => {
    const {
      pastOrders: { orderMedicinesMap },
      orderDetails,
    } = this.props;

    if (!orderMedicinesMap[orderDetails.id]) {
      this.props.actions.fetchOrderDetails(
        { orderId: orderDetails.id },
        this.props.customer.omsEnabled && this.props.orderDetails.isNewOrderFlow
      );
    }
    this.setState({
      isCollapsed: !this.state.isCollapsed,
      medicines: orderMedicinesMap[orderDetails.id] || [],
    });
  };

  render() {
    const {
      orderDetails,
      index,
      currentIndex,
      customer: { omsEnabled = false } = {},
    } = this.props;
    const { isCollapsed, medicines, isOrderDelivered } = this.state;
    const { buttonInfo = {} } = orderDetails;
    return (
      <div
        className={`PastOrderItemContainer ${!isCollapsed ? "selected" : ""} ${
          index == currentIndex ? " ActiveItem" : ""
        }`}
      >
        <div
          className={`orderHeader ${isOrderDelivered ? "orderDelivered" : ""}`}
          tabIndex={0}
          onClick={this.toggleMedicineView}
        >
          <div className="orderHeaderContainer1">
            <div className="orderHeaderTitle">Patient Name</div>
            <div className="orderHeaderValue">
              {orderDetails.patientName || orderDetails.name}
            </div>
          </div>
          <div className="orderHeaderContainer2">
            <div className="orderHeaderTitle">Order Id</div>
            <div className="orderHeaderValue">{orderDetails.id}</div>
          </div>
          <div className="orderHeaderContainer2">
            <div className="orderHeaderTitle">
              {omsEnabled
                ? "Placed On"
                : isOrderDelivered
                ? "Delivered on"
                : "EDD"}
            </div>
            <div className="orderHeaderValue">
              {orderDetails.estdDeliveryDate || orderDetails.placedAt}
            </div>
          </div>
          {!isOrderDelivered && (
            <div className="orderHeaderContainer1">
              <div className="orderHeaderTitle">Status</div>
              <div className="orderHeaderValue">
                {orderDetails.status.message || orderDetails.status.text}
              </div>
            </div>
          )}
          {
            <div className="orderHeaderContainer1" onClick={e => e.stopPropagation()}>
              {(isOrderDelivered || buttonInfo.type === "REORDER") && (
                <OrderOnCallButton
                  text="ADD ALL MEDICINES"
                  type={1}
                  loading={false}
                  onClickFunction={this.addAllMedicines}
                />
              )}
            </div>
          }
          {(isOrderDelivered || omsEnabled) && (
            <div
              className="showHideArrow"
              dangerouslySetInnerHTML={{
                __html: !isCollapsed ? "&#x25B2;" : "&#x25BC;",
              }}
            />
          )}
        </div>
        {!isCollapsed && (
          <div className="orderContent">
            {(isOrderDelivered || omsEnabled) && medicines.length > 0 ? (
              <MedicineList
                medicines={medicines}
                className="pastOrderMedicines"
              />
            ) : (
              <div className="medicineMessage">fetching data...</div>
            )}
          </div>
        )}
      </div>
    );
  }
};

PastOrderItem.propTypes = {
  orderDetails: PropTypes.object,
  actions: PropTypes.object,
  pastOrders: PropTypes.object,
  customer: PropTypes.object.isRequired,
};

PastOrderItem.defaultProps = {
  orderDetails: {},
  actions: {},
  pastOrders: {}
};

export default connect(state => ({
  pastOrders: state.pastOrders,
  customer: state.customer,
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(PastOrderItem);
